import { UseCase, DigestFrequency } from '../types/onboarding';

export interface UseCaseOption {
  value: UseCase;
  label: string;
}

export interface DigestFrequencyOption {
  value: DigestFrequency;
  label: string;
  disabled: boolean;
  tooltipText?: string;
}

export const USE_CASE_OPTIONS: UseCaseOption[] = [
  { value: 'myself', label: 'Myself' },
  { value: 'business', label: 'My business' },
  { value: 'both', label: 'Both' },
];

export const DIGEST_FREQUENCY_OPTIONS: DigestFrequencyOption[] = [
  { value: 1, label: '1x', disabled: false },
  { value: 3, label: '3x', disabled: false },
  { value: 5, label: '5x', disabled: false },
  { value: 7, label: '7x', disabled: true, tooltipText: 'Digests are limited to weekdays during the alpha period.' },
];
